import { Layers, Plus } from "lucide-react";
import { FigmaTypography } from "@libs/zapi-ui/custom";
import { useTranslation } from "react-i18next";

export function EmptyDimensionsState() {
  const { t } = useTranslation("projects");
  return (
    <div className="flex flex-col items-center justify-center gap-[18px] px-5 py-12">
      <div className="relative flex h-[52px] w-[52px] items-center justify-center">
        <Layers className="h-10 w-10 text-[#d4d4d8]" strokeWidth={1.5} />
        <span className="absolute -bottom-0.5 -right-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-white">
          <Plus className="h-3.5 w-3.5 text-[#d4d4d8]" strokeWidth={2} />
        </span>
      </div>
      <div className="flex flex-col items-center gap-3">
        <p className="text-base font-medium leading-[15px] text-[#18181b]">{t("dimensions.emptyTitle")}</p>
        <FigmaTypography variant="body-3" className="w-[184px] text-center text-[#71717a]">
          {t("dimensions.emptyBody")}
        </FigmaTypography>
      </div>
    </div>
  );
}
